<template>
  <el-row id="app">
    <el-col>
      <el-row>
        <el-col :span="12">
          <el-row>
            <el-col :span="24">
              <amount-out />
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row>
            <el-col :span="24">
             <amount-in />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>

import AmountIn from '@/components/AmountIn'
import AmountOut from '@/components/AmountOut'

export default {
  name: 'HelloWorld',
  data () {
    return {
     
    }
  },
  components: {
      AmountIn,
      AmountOut
    },
  mounted() {
   
  },
  methods: {
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ByAmount.vue